"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsonld_context_parser_1 = require("jsonld-context-parser");

var stream_1 = require("stream");

var SeparatorType_1 = require("./SeparatorType");

var Util_1 = require("./Util");
/**
 * A stream transformer that transforms an {@link RDF.Stream} into a JSON-LD (text) stream.
 */


var JsonLdSerializer =
/*#__PURE__*/
function (_stream_1$Transform) {
  _inherits(JsonLdSerializer, _stream_1$Transform);

  function JsonLdSerializer() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, JsonLdSerializer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(JsonLdSerializer).call(this, {
      objectMode: true
    }));
    _this.indentation = 0;
    _this.options = options; // Parse the context

    if (_this.options.baseIRI && !_this.options.context) {
      _this.options.context = {
        '@base': _this.options.baseIRI
      };
    }

    if (_this.options.context) {
      _this.originalContext = _this.options.context;
      _this.context = new jsonld_context_parser_1.ContextParser().parse(_this.options.context, {
        baseIri: _this.options.baseIRI
      });
    } else {
      _this.context = Promise.resolve({});
    }

    return _this;
  }
  /**
   * Parses the given text stream into a quad stream.
   * @param {NodeJS.EventEmitter} stream A text stream.
   * @return {NodeJS.EventEmitter} A quad stream.
   */


  _createClass(JsonLdSerializer, [{
    key: "import",
    value: function _import(stream) {
      var output = new stream_1.PassThrough({
        objectMode: true
      });
      stream.on('error', function (error) {
        return parsed.emit('error', error);
      });
      stream.on('data', function (data) {
        return output.write(data);
      });
      stream.on('end', function () {
        return output.emit('end');
      });
      var parsed = output.pipe(new JsonLdSerializer(this.options));
      return parsed;
    }
    /**
     * Transforms a quad into the text stream.
     * @param {Quad} quad An RDF quad.
     * @param {string} encoding An (ignored) encoding.
     * @param {module:stream.internal.TransformCallback} callback Callback that is invoked when the transformation is done
     * @private
     */

  }, {
    key: "_transform",
    value: function _transform(quad, encoding, callback) {
      var _this2 = this;

      this.context.then(function (context) {
        _this2.transformQuad(quad, context);

        callback();
      }).catch(callback);
    }
    /**
     * Construct a list in an RDF.Term object that can be used
     * inside a quad's object to write into the serializer
     * as a list using the @list keyword.
     * @param {Term[]} values A list of values, can be empty.
     * @return {Term} A term that should be used in the object position of the quad that is written to the serializer.
     */

  }, {
    key: "list",
    value: function list(values) {
      var _this3 = this;

      return {
        '@list': values.map(function (value) {
          return Util_1.Util.termToValue(value, _this3.options);
        })
      };
    }
    /**
     * Claled when the incoming stream is closed.
     * @param {module:stream.internal.TransformCallback} callback Callback that is invoked when the flushing is done.
     * @private
     */

  }, {
    key: "_flush",
    value: function _flush(callback) {
      // If the stream was empty, ensure that we push the opening array
      if (!this.opened) {
        this.pushDocumentStart();
      }

      if (this.lastPredicate) {
        this.endPredicate();
      }

      if (this.lastSubject) {
        this.endSubject();
      }

      if (this.lastGraph && this.lastGraph.termType !== 'DefaultGraph') {
        this.endGraph();
      }

      this.endDocument();
      return callback(null, null);
    }
    /**
     * Transforms a quad into the text stream.
     * @param {Quad} quad An RDF quad.
     * @param {IJsonLdContextNormalized} context A context for compacting.
     */

  }, {
    key: "transformQuad",
    value: function transformQuad(quad, context) {
      // Open the array before the first quad
      if (!this.opened) {
        this.pushDocumentStart();
      } // Check if the subject equals the last named graph
      // In that case, we can reuse the already-existing @id node


      var lastGraphMatchesSubject = this.lastGraph && this.lastGraph.termType !== 'DefaultGraph' && this.lastGraph.equals(quad.subject); // Write graph

      if (!lastGraphMatchesSubject && (!this.lastGraph || !quad.graph.equals(this.lastGraph))) {
        // Check if the named graph equals the last subject
        // In that case, we can reuse the already-existing @id node
        var lastSubjectMatchesGraph = quad.graph.termType !== 'DefaultGraph' && this.lastSubject && this.lastSubject.equals(quad.graph);

        if (this.lastGraph) {
          if (this.lastGraph.termType !== 'DefaultGraph') {
            // The last graph was named
            this.endPredicate();
            this.endSubject();
            this.endGraph(true);
            lastSubjectMatchesGraph = false; // Special-case to avoid deeper nesting
          } else {
            // The last graph was default
            if (!lastSubjectMatchesGraph) {
              this.endPredicate();
              this.endSubject(true);
            } else {
              this.endPredicate(true);
              this.lastSubject = null;
            }
          }
        } // Push the graph


        if (quad.graph.termType !== 'DefaultGraph') {
          if (!lastSubjectMatchesGraph) {
            this.pushId(quad.graph, context);
          }

          this.pushSeparator(this.options.space ? SeparatorType_1.SeparatorType.GRAPH_FIELD_NONCOMPACT : SeparatorType_1.SeparatorType.GRAPH_FIELD_COMPACT);
          this.indentation++;
        }

        this.lastGraph = quad.graph;
      } // Write subject


      if (!this.lastSubject || !quad.subject.equals(this.lastSubject)) {
        if (lastGraphMatchesSubject) {
          this.endPredicate();
          this.endSubject();
          this.indentation--;
          this.pushSeparator(SeparatorType_1.SeparatorType.ARRAY_END_COMMA);
          this.lastGraph = quad.graph;
        } else {
          if (this.lastSubject) {
            this.endPredicate();
            this.endSubject(true);
          } // Open a new node for the new subject


          this.pushId(quad.subject, context);
        }

        this.lastSubject = quad.subject;
      } // Write predicate


      if (!this.lastPredicate || !quad.predicate.equals(this.lastPredicate)) {
        if (this.lastPredicate) {
          this.endPredicate(true);
        } // Open a new array for the new predicate


        this.pushPredicate(quad.predicate, context);
      } // Write the object value


      this.pushObject(quad.object, context);
    }
  }, {
    key: "pushDocumentStart",
    value: function pushDocumentStart() {
      this.opened = true;

      if (this.originalContext && !this.options.excludeContext) {
        this.pushSeparator(SeparatorType_1.SeparatorType.OBJECT_START);
        this.indentation++;
        this.pushSeparator(SeparatorType_1.SeparatorType.CONTEXT_FIELD);
        this.pushIndented(JSON.stringify(this.originalContext, null, this.options.space) + ',');
        this.pushSeparator(this.options.space ? SeparatorType_1.SeparatorType.GRAPH_FIELD_NONCOMPACT : SeparatorType_1.SeparatorType.GRAPH_FIELD_COMPACT);
        this.indentation++;
      } else {
        this.pushSeparator(SeparatorType_1.SeparatorType.ARRAY_START);
        this.indentation++;
      }
    }
    /**
     * Push the given term as an @id field.
     * @param {Term} term An RDF term.
     * @param {IJsonLdContextNormalized} context The context.
     */

  }, {
    key: "pushId",
    value: function pushId(term, context) {
      var subjectValue = term.termType === 'BlankNode' ? '_:' + term.value : jsonld_context_parser_1.ContextParser.compactIri(term.value, context, false);
      this.pushSeparator(SeparatorType_1.SeparatorType.OBJECT_START);
      this.indentation++;
      this.pushIndented(this.options.space ? "\"@id\": \"".concat(subjectValue, "\",") : "\"@id\":\"".concat(subjectValue, "\","));
    }
    /**
     * Push the given predicate field.
     * @param {Term} predicate An RDF term.
     * @param {IJsonLdContextNormalized} context The context.
     */

  }, {
    key: "pushPredicate",
    value: function pushPredicate(predicate, context) {
      var property = predicate.value; // Convert rdf:type into @type if not disabled.

      if (!this.options.useRdfType && property === Util_1.Util.RDF_TYPE) {
        property = '@type';
        this.objectOptions = Object.assign({}, this.options, {
          compactIds: true,
          vocab: true
        });
      } // Open array for following objects


      var compactedProperty = jsonld_context_parser_1.ContextParser.compactIri(property, context, true);
      this.pushIndented(this.options.space ? "\"".concat(compactedProperty, "\": [") : "\"".concat(compactedProperty, "\":["));
      this.indentation++;
      this.lastPredicate = predicate;
    }
    /**
     * Push the given object value.
     * @param {Term} object An RDF term.
     * @param {IJsonLdContextNormalized} context The context.
     */

  }, {
    key: "pushObject",
    value: function pushObject(object, context) {
      // Add a comma if we already had an object for this predicate
      if (!this.hadObjectForPredicate) {
        this.hadObjectForPredicate = true;
      } else {
        this.pushSeparator(SeparatorType_1.SeparatorType.COMMA);
      } // Convert the object into a value and push it


      var value;

      try {
        if (object['@list']) {
          value = object;
        } else {
          value = Util_1.Util.termToValue(object, context, this.objectOptions || this.options);
        }
      } catch (e) {
        return this.emit('error', e);
      }

      this.pushIndented(JSON.stringify(value, null, this.options.space));
    }
  }, {
    key: "endDocument",
    value: function endDocument() {
      this.opened = false;

      if (this.originalContext && !this.options.excludeContext) {
        this.indentation--;
        this.pushSeparator(SeparatorType_1.SeparatorType.ARRAY_END);
        this.indentation--;
        this.pushSeparator(SeparatorType_1.SeparatorType.OBJECT_END);
      } else {
        this.indentation--;
        this.pushSeparator(SeparatorType_1.SeparatorType.ARRAY_END);
      }
    }
    /**
     * Push the end of a predicate and reset the buffers.
     * @param {boolean} comma If a comma should be appended.
     */

  }, {
    key: "endPredicate",
    value: function endPredicate(comma) {
      // Close the predicate array
      this.indentation--;
      this.pushSeparator(comma ? SeparatorType_1.SeparatorType.ARRAY_END_COMMA : SeparatorType_1.SeparatorType.ARRAY_END); // Reset object buffer

      this.hadObjectForPredicate = false;
      this.objectOptions = null; // Reset predicate buffer

      this.lastPredicate = null;
    }
    /**
     * Push the end of a subject and reset the buffers.
     * @param {boolean} comma If a comma should be appended.
     */

  }, {
    key: "endSubject",
    value: function endSubject(comma) {
      // Close the last subject's node;
      this.indentation--;
      this.pushSeparator(comma ? SeparatorType_1.SeparatorType.OBJECT_END_COMMA : SeparatorType_1.SeparatorType.OBJECT_END); // Reset subject buffer

      this.lastSubject = null;
    }
    /**
     * Push the end of a graph and reset the buffers.
     * @param {boolean} comma If a comma should be appended.
     */

  }, {
    key: "endGraph",
    value: function endGraph(comma) {
      // Close the graph array
      this.indentation--;
      this.pushSeparator(SeparatorType_1.SeparatorType.ARRAY_END); // Close the graph id node

      this.indentation--;
      this.pushSeparator(comma ? SeparatorType_1.SeparatorType.OBJECT_END_COMMA : SeparatorType_1.SeparatorType.OBJECT_END); // Reset graph buffer

      this.lastGraph = null;
    }
    /**
     * Puh the given separator.
     * @param {SeparatorType} type A type of separator.
     */

  }, {
    key: "pushSeparator",
    value: function pushSeparator(type) {
      this.pushIndented(type.label);
    }
    /**
     * An indentation-aware variant of {@link #push}.
     * All strings that are pushed here will be prefixed by {@link #indentation} amount of spaces.
     * @param {string} data A string.
     */

  }, {
    key: "pushIndented",
    value: function pushIndented(data) {
      var prefix = this.getIndentPrefix();
      var lines = data.split('\n').map(function (line) {
        return prefix + line;
      }).join('\n');
      this.push(lines);

      if (this.options.space) {
        this.push('\n');
      }
    }
    /**
     * @return {string} Get the current indentation prefix based on {@link #indentation}.
     */

  }, {
    key: "getIndentPrefix",
    value: function getIndentPrefix() {
      return this.options.space ? this.options.space.repeat(this.indentation) : '';
    }
  }]);

  return JsonLdSerializer;
}(stream_1.Transform);

exports.JsonLdSerializer = JsonLdSerializer;